import React from 'react'

import './Blog.css'

const Blog = () => {
  return (
    <div id='Blog'>
      Welcome to Blog
    </div>
  )
}

export default Blog



// WEBPACK FOOTER //
// ./src/components/Blog/Blog.js